@if ($allowCompany()) {
  <!-- <section class="advert text-center">
    🚚 FREE SHIPPING on all orders $175+ *
  </section> -->
  <div class="navbar-container login-header">
    <div class="container-nav1 px-4">
      <!-- MOBILE NAV BAR -->
      <nav class="navbar1 navbar-expand-lg d-sm-flex">
        <div class="col-4 p-0 d-flex flex-row d-sm-flex d-md-none">
          <div
            class="d-flex d-sm-none"
            (click)="showMobileMenu = !showMobileMenu"
          >
            <i
              class="pi pi-bars pr-4"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
          <div>
            <nav *ngIf="showMobileMenu" class="mobile-menu d-sm-none">
              <div class="close-icon" (click)="closeMobileMenu()">
                <i
                  class="pi pi-times"
                  style="font-size: 20px; cursor: pointer"
                ></i>
              </div>

              <ul class="mobile-menu-list">
                <!-- Loop through parent menu items -->
                @for (item of $menusItems(); track $index; let i = $index) {
                  <li class="mobile-menu-item">
                    <a
                      class="mobile-menu-link flex justify-content-between"
                      (click)="toggleSubmenu(i)"
                    >
                      {{ item.title }}
                      <!-- Indicator for expandable items -->
                      <i
                        *ngIf="item.childs.length > 0"
                        class="pi"
                        [ngClass]="
                          expandedIndex === i
                            ? 'pi-chevron-down'
                            : 'pi-chevron-right'
                        "
                      ></i>
                    </a>

                    <!-- Submenu items, only visible for the currently expanded parent -->
                    <ul *ngIf="expandedIndex === i" class="mobile-submenu">
                      @for (
                        subItem of item.childs;
                        track $index;
                        let j = $index
                      ) {
                        <li class="mobile-submenu-item">
                          <a
                            [routerLink]="[
                              '/category',
                              item.alias,
                              subItem.alias,
                            ]"
                            class="mobile-submenu-link"
                            (click)="closeMobileMenu()"
                          >
                            {{ subItem.title }}
                          </a>
                        </li>
                      }
                    </ul>
                  </li>
                }
              </ul>
              <ul style="margin-top: 20px" class="mobile-menu-list">
                <li
                  (click)="closeMobileMenu()"
                  routerLink="/resources/contact-us"
                >
                  <a class="mobile-menu-link flex justify-content-between">
                    Contact Us
                    <span class="pi pi-chevron-right"></span>
                  </a>
                </li>
              </ul>
              <ul
                style="margin-top: 20px"
                class="mobile-menu-list"
                *ngIf="$currentUser()?.default_user"
              >
                <li
                  class="flex gap-3 align-items-center justify-content-center border-round p-3 text-0 hover:surface-900"
                  style="background-color: #0979bd"
                >
                  <i
                    class="pi pi-sign-in"
                    style="font-size: 1.3rem; margin-bottom: 2px"
                  ></i>
                  <a
                    (click)="closeMobileMenu()"
                    (click)="callLogin()"
                    class="mobile-menu-link text-0"
                  >
                    Sign In your account
                  </a>
                </li>
                <li
                  class="flex gap-3 align-items-center justify-content-center border-round p-3 text-0 surface-900 hover:surface-800"
                  style="margin-top: 15px"
                >
                  <i
                    class="pi pi-user"
                    style="font-size: 1.3rem; margin-bottom: 2px"
                  ></i>
                  <a
                    (click)="closeMobileMenu()"
                    (click)="callRegister()"
                    class="mobile-menu-link text-0"
                  >
                    Create a new account
                  </a>
                </li>
              </ul>

              <ul
                style="margin-top: 20px"
                class="mobile-menu-list"
                *ngIf="!$currentUser()?.default_user"
              >
                <li>
                  <a
                    class="mobile-menu-link flex justify-content-between"
                    (click)="toggleDropdown()"
                    >My account
                    <i
                      class="pi"
                      [ngClass]="
                        isDropdownOpen ? 'pi-chevron-down' : 'pi-chevron-right'
                      "
                    ></i
                  ></a>
                  <ul class="mobile-submenu" *ngIf="isDropdownOpen">
                    <li
                      routerLink="/resources/accountInfo"
                      (click)="closeMobileMenu()"
                      class="mobile-submenu-link mobile-submenu-item"
                    >
                      Account Settings
                    </li>
                    <li
                      class="mobile-submenu-link mobile-submenu-item"
                      routerLink="/{{ backToCartLink$() }}/list"
                      (click)="closeMobileMenu()"
                    >
                      Order History
                    </li>
                    <li
                      class="mobile-submenu-link mobile-submenu-item"
                      (click)="logOut()"
                    >
                      <a>Logout</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>

          <div>
            <i
              class="pi pi-search"
              style="color: #000000; font-size: 20px; cursor: pointer"
              (click)="showIconField = !showIconField"
            >
            </i>
            <div
              style="
                width: 100%;
                height: 145px;
                top: 0;
                left: 0;
                z-index: 1000;
                position: fixed;
              "
              class="fadeinup animation-duration-200 surface-0 flex flex-column gap-2 justify-content-center align-items-center border-bottom border-300 px-4"
              *ngIf="showIconField"
            >
              <div
                class="flex justify-content-between w-full align-items-center"
              >
                <span class="text-2xl"> Search our store</span>
                <i
                  class="pi pi-times"
                  style="font-size: 18px; cursor: pointer; color: #000000"
                  (click)="showIconField = false"
                ></i>
              </div>

              <input
                #searchInput
                class="form-control form-control-lg"
                name="random_box"
                id="random_box"
                type="text"
                [formControl]="searchControl"
                placeholder="Search"
                aria-label="Search"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                readonly
                onfocus="this.removeAttribute('readonly')"
                onfocusout="this.setAttribute('readonly', 'true')"
                (keyup.enter)="onSearch()"
              />
              <p-button
                [style]="{ 'background-color': '#0979BD' }"
                styleClass="border-round w-full text-xl border-none mt-1"
                icon="pi pi-search"
                label="Search"
                (onClick)="onSearch()"
              />
            </div>
          </div>
        </div>
        <div
          class="col-4 p-0 flex justify-content-md-start justify-content-center"
        >
          <a class="navbar-brand" routerLink="/">
            @if ($currentUser() && $currentUser()?.company?.logo_file) {
              <img
                class="logo c-ml-20 c-mh-60"
                src="{{ displayImage($currentUser()?.company?.logo_file) }}"
                alt="{{ $currentUser()?.company?.company_name }} Logo"
                title="{{ $currentUser()?.company?.company_name }}"
              />
            }
          </a>
        </div>
        <div class="col-4 p-0" id="navbarCollapse">
          <p-iconField class="d-flex d-none d-sm-flex" iconPosition="right">
            <p-inputIcon styleClass="pi pi-search pr-2 text-900	" />
            <input
              #searchInput
              class="form-control form-control-lg"
              name="random_box"
              id="random_box"
              type="text"
              [formControl]="searchControl"
              placeholder="Search"
              aria-label="Search"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              readonly
              onfocus="this.removeAttribute('readonly')"
              onfocusout="this.setAttribute('readonly', 'true')"
              (keyup.enter)="onSearch()"
            />
          </p-iconField>

          <ul class="navbar-nav d-flex flex-row">
            <li class="flex nav-item align-items-center d-none d-md-block">
              <div>
                <a class="nav-link" [routerLink]="['/resources/contact-us']">
                  <i
                    class="pi pi-question-circle"
                    style="color: #000000; font-size: 22px"
                    pTooltip="Let's get in touch!"
                    tooltipPosition="bottom"
                  ></i>
                </a>
              </div>
            </li>

            @if (!$currentUser()?.default_user || $companyId() !== 10026) {
              <li *ngIf="$currentUser()?.company?.use_qo" class="nav-item">
                <div class="shopping-cart">
                  <span>
                    <ng-container *ngIf="$lastedQO()?.['_id']; else noQO">
                      <a
                        class="nav-link"
                        [routerLink]="[
                          '/quotation/detail/edit',
                          $lastedQO()._id,
                        ]"
                      >
                        <i
                          class="pi pi-receipt"
                          style="color: #000000; font-size: 22px"
                        ></i>
                        <span class="quotation-badge">
                          @if (
                            $lastedQO().order_item_list &&
                            $lastedQO().order_item_list.length
                          ) {
                            {{ $lastedQO().order_item_list.length }}
                          } @else {
                            0
                          }
                        </span>
                      </a>
                    </ng-container>
                    <ng-template #noQO>
                      <a class="nav-link" [routerLink]="['/quotation/list']">
                        <i
                          class="pi pi-receipt"
                          style="color: #000000; font-size: 22px"
                        ></i>
                      </a>
                    </ng-template>
                  </span>

                  <span class="tooltip" style="font-size: 14px">
                    @if (
                      $lastedQO().order_item_list &&
                      $lastedQO().order_item_list.length
                    ) {
                      You have {{ $lastedQO().order_item_list.length }} item in
                      your quotation
                    } @else {
                      Your quotation is empty
                    }
                  </span>
                </div>
              </li>
              <li class="nav-item">
                <div class="shopping-cart">
                  <span>
                    <ng-container *ngIf="$lastedOrder()?.['_id']; else noOrder">
                      <a
                        class="nav-link"
                        [routerLink]="[
                          '/' + backToCartLink$() + '/detail/edit',
                          $lastedOrder()._id,
                        ]"
                      >
                        <i
                          class="pi pi-shopping-cart"
                          style="color: #000000; font-size: 22px"
                        ></i>
                        <span class="shopping-badge">
                          @if (
                            $lastedOrder().order_item_list &&
                            $lastedOrder().order_item_list.length
                          ) {
                            {{ $lastedOrder().order_item_list.length }}
                          } @else {
                            0
                          }
                        </span>
                      </a>
                    </ng-container>
                    <ng-template #noOrder>
                      <a
                        class="nav-link"
                        [routerLink]="[
                          '/' + backToCartLink$() + '/detail/edit',
                          'empty',
                        ]"
                      >
                        <i
                          class="pi pi-shopping-cart"
                          style="color: #000000; font-size: 22px"
                        ></i>
                      </a>
                    </ng-template>
                  </span>

                  <span class="tooltip" style="font-size: 14px">
                    @if (
                      $lastedOrder().order_item_list &&
                      $lastedOrder().order_item_list.length
                    ) {
                      You have {{ $lastedOrder().order_item_list.length }} item
                      in your cart
                    } @else {
                      Your cart is empty
                    }
                  </span>
                </div>
              </li>
            }

            <li
              class="nav-item d-none d-md-block"
              *ngIf="!$currentUser()?.default_user"
            >
              <div class="user-menu" #dropdownMenu>
                <input
                  type="checkbox"
                  id="toggleDropdown"
                  class="toggle-checkbox"
                  #toggleCheckbox
                />
                <label for="toggleDropdown" class="user-avatar">
                  <span style="font-weight: 550; font-size: 16px">{{
                    getInitials(
                      $currentUser()?.user_first_name +
                        ' ' +
                        $currentUser()?.user_last_name
                    ) | uppercase
                  }}</span>
                  <span class="tooltip tooltip-welcome" style="font-size: 14px"
                    >Welcome
                    {{
                      $currentUser()?.user_first_name +
                        ' ' +
                        $currentUser()?.user_last_name
                    }}</span
                  >
                </label>
                <div class="dropdown" [class.show]="toggleCheckbox.checked">
                  <ul class="dropdown-content">
                    <li
                      routerLink="/resources/accountInfo"
                      (click)="closeDropdown()"
                    >
                      <i class="fas fa-user"></i>
                      {{
                        $currentUser()?.user_first_name +
                          ' ' +
                          $currentUser()?.user_last_name
                      }}'s Account
                    </li>
                    <li
                      routerLink="/{{ backToCartLink$() }}/list"
                      (click)="closeDropdown()"
                    >
                      <i class="fas fa-history"></i> Order History
                    </li>
                    <li
                      *ngIf="$currentUser()?.company?.use_qo"
                      routerLink="/quotation/list"
                      (click)="closeDropdown()"
                    >
                      <i class="fas fa-list-alt"></i> Quotation History
                    </li>
                    <li
                      routerLink="/resources/contact-us"
                      (click)="closeDropdown()"
                    >
                      <i class="pi pi-phone" style="font-size: 14px"></i>Contact
                      Us
                    </li>
                    <li (click)="logOut()">
                      <i class="fas fa-sign-out-alt"></i>
                      <a>Logout</a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>

          <ul
            *ngIf="$currentUser()?.default_user"
            class="navbar-nav d-flex flex-row d-none d-md-block gap-3"
          >
            <li
              class="nav-item"
              routerLink="/resources/contact-us"
              style="cursor: pointer"
              title="Contact Us"
            >
              <i class="pi pi-envelope" style="font-size: 20px"></i>
            </li>
            <li class="nav-item" (click)="callLogin()" style="cursor: pointer">
              <i class="pi pi-user" style="font-size: 20px"></i>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="container-nav2 d-flex d-none d-sm-flex">
      <nav class="navbar2">
        @if ($totalCount() > 6) {
          <ul class="menu" style="justify-content: space-between">
            @for (item of $menusItems(); track $index; let i = $index) {
              <li class="menu-item">
                <a
                  class="menu-link"
                  [routerLink]="['/category', item.alias]"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  {{ item.title }}
                </a>
                @if (item.childs.length > 6) {
                  <ul class="submenu">
                    @for (
                      subItem of item.childs;
                      track $index;
                      let j = $index
                    ) {
                      <li class="submenu-item">
                        <a
                          [routerLink]="[
                            '/category',
                            item.alias,
                            subItem.alias,
                          ]"
                          class="submenu-link"
                        >
                          {{ subItem.title }}
                        </a>
                      </li>
                    }
                  </ul>
                } @else {
                  <ul class="submenu" style="width: 200px">
                    @for (
                      subItem of item.childs;
                      track $index;
                      let j = $index
                    ) {
                      <li class="submenu-item">
                        <a
                          [routerLink]="[
                            '/category',
                            item.alias,
                            subItem.alias,
                          ]"
                          class="submenu-link"
                        >
                          {{ subItem.title }}
                        </a>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        } @else {
          <ul class="menu" style="justify-content: start">
            @for (item of $menusItems(); track $index; let i = $index) {
              <li class="menu-item" style="padding-right: 30px">
                <a
                  class="menu-link"
                  [routerLink]="['/category', item.alias]"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  {{ item.title }}
                  <i class="pi pi-angle-down ml-1"></i>
                </a>
                @if (item.childs.length > 6) {
                  <ul
                    class="submenu"
                    style="grid-template-columns: repeat(2, 1fr); width: 300px"
                  >
                    @for (
                      subItem of item.childs;
                      track $index;
                      let j = $index
                    ) {
                      <li class="submenu-item">
                        <a
                          [routerLink]="[
                            '/category',
                            item.alias,
                            subItem.alias,
                          ]"
                          class="submenu-link"
                        >
                          {{ subItem.title }}
                        </a>
                      </li>
                    }
                  </ul>
                } @else {
                  <ul class="submenu" style="width: 200px">
                    @for (
                      subItem of item.childs;
                      track $index;
                      let j = $index
                    ) {
                      <li class="submenu-item">
                        <a
                          [routerLink]="[
                            '/category',
                            item.alias,
                            subItem.alias,
                          ]"
                          class="submenu-link"
                        >
                          {{ subItem.title }}
                        </a>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        }
      </nav>
    </div>
  </div>
}

<div class="custom-dialog">
  <p-dialog
    [draggable]="false"
    [modal]="true"
    [(visible)]="popupLogin"
    styleClass="dialog-responsive pb-6 mx-3 m-md-0 custom-dialog"
    [closable]="true"
    [style]="{ width: '1000px' }"
    [closeOnEscape]="true"
  >
    <div class="d-flex flex-column flex-md-row">
      <div class="overflow-hidden col-12 col-md-6 p-0 d-none d-md-block">
        <p-image
          src="{{ login_banner | assetUrl }}"
          [style]="{ width: '100%', height: '100%' }"
          [imageStyle]="{ objectFit: 'cover', width: '100%', height: '100%' }"
        >
        </p-image>
      </div>

      <div class="col-12 col-md-6">
        <form [formGroup]="formGroup" (ngSubmit)="login()" autocomplete="off">
          <div class="flex justify-content-end pt-3 pr-3 p-md-4">
            <p-button
              styleClass="border-circle w-2rem h-2rem bg-gray-700 border-gray-700"
              icon="pi pi-times"
              (onClick)="popupLogin = 0"
            />
          </div>
          <div class="flex flex-column w-full px-3 px-md-5 pb-4 gap-4">
            <h1 class="text-900 text-center">Customer Login</h1>
            <p-iconField iconPosition="right">
              <p-inputIcon styleClass="pi pi-user px-3" />
              <input
                pInputText
                type="text"
                placeholder="Email"
                class="w-full border-round border-1 border-gray-300 overflow-hidden px-3"
                formControlName="username"
                style="height: 50px"
              />
            </p-iconField>

            <p-iconField iconPosition="right">
              <a
                class="pointer"
                *ngIf="!showPass"
                (click)="showPass = !showPass"
                ><p-inputIcon styleClass="pi pi-eye px-3"
              /></a>
              <a
                class="pointer"
                *ngIf="showPass"
                (click)="showPass = !showPass"
              >
                <p-inputIcon styleClass="pi pi-eye-slash px-3" />
              </a>
              <input
                pInputText
                type="{{ !showPass ? 'password' : 'text' }}"
                placeholder="Password"
                class="w-full border-round border-1 border-gray-300 overflow-hidden px-3"
                formControlName="password"
                (keydown.enter)="login()"
                style="height: 50px"
              />
            </p-iconField>

            <div class="flex justify-content-between">
              <a
                (click)="forgotPassword()"
                style="
                  text-decoration: underline;
                  font-style: italic;
                  font-size: 13px;
                "
                class="pointer"
              >
                Forgot Password?
              </a>
            </div>

            <p-button
              label="Sign in"
              [rounded]="true"
              [style]="{ width: '100%', 'font-size': '15px' }"
              [disabled]="formGroup.invalid"
              (click)="login()"
              [loading]="isLoading"
              styleClass="border-round border-2 transition-colors hover:surface-900 hover:border-900 checkout-button"
            ></p-button>

            <p-divider align="center" styleClass="m-0">
              <b>OR</b>
            </p-divider>

            <p-button
              label="Create an account"
              [rounded]="true"
              [style]="{ width: '100%', 'font-size': '15px' }"
              styleClass="border-round border-2 transition-colors hover:surface-900 hover:border-900 add-to-cart-upload-later"
              (click)="callRegister()"
            ></p-button>
          </div>
        </form>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    [draggable]="false"
    [modal]="true"
    [(visible)]="popupForgetPassword"
    styleClass="dialog-responsive pb-6 mx-3 m-md-0"
    [closable]="true"
    [style]="{ width: '500px' }"
    [closeOnEscape]="true"
  >
    <form [formGroup]="forgetEmailFormGroup" autocomplete="off">
      <div class="d-flex flex-column flex-md-row">
        <div class="col-12 col-md-12">
          <div class="flex justify-content-end pr-3 pt-3">
            <p-button
              styleClass="border-circle w-2rem h-2rem bg-gray-700 border-gray-700"
              icon="pi pi-times"
              (onClick)="popupForgetPassword = 0"
            />
          </div>
          <div class="flex flex-column w-full px-3 px-md-5 pb-4 gap-4">
            <h1 class="text-900 text-center">Forgot Password?</h1>
            <p-iconField iconPosition="right">
              <p-inputIcon styleClass="pi pi-user px-3" />
              <input
                type="text"
                placeholder="Email address"
                class="w-full border-round border-1 border-gray-300 overflow-hidden px-3"
                formControlName="forget_email"
                style="height: 50px"
              />
            </p-iconField>

            <p-button
              label="Reset password"
              [rounded]="true"
              [style]="{ width: '100%', 'font-size': '15px' }"
              [disabled]="forgetEmailFormGroup.invalid"
              (click)="resetPassword()"
              styleClass="border-round border-2 transition-colors hover:surface-900 hover:border-900 checkout-button"
            ></p-button>

            <div class="flex justify-content-center">
              <a
                (click)="callLogin()"
                style="
                  text-decoration: underline;
                  font-style: italic;
                  font-size: 13px;
                "
                class="pointer"
              >
                Back to Log In
              </a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </p-dialog>

  <p-dialog
    [draggable]="false"
    [modal]="true"
    [(visible)]="popupRegister"
    [closable]="true"
    [style]="{ width: '500px' }"
    [closeOnEscape]="true"
    styleClass="dialog-responsive pb-6 mx-3 m-md-0"
    (onHide)="handleDialogHide()"
  >
    <form [formGroup]="registerFormGroup" autocomplete="off">
      <div class="d-flex flex-column flex-md-row">
        <div class="col-12 col-md-12">
          <div class="flex justify-content-end pr-3 pt-3">
            <p-button
              styleClass="border-circle w-2rem h-2rem bg-gray-700 border-gray-700"
              icon="pi pi-times"
              (onClick)="popupRegister = 0"
            />
          </div>
          <div class="flex flex-column w-full px-3 px-md-5 pb-6 gap-4">
            <h1 class="text-900 text-center">Account Sign Up</h1>
            <div class="flex gap-4">
              <input
                type="text"
                placeholder="First Name"
                class="w-full border-round border-1 border-gray-300 overflow-hidden px-3"
                formControlName="user_first_name"
                style="height: 50px"
              />
              <input
                type="text"
                placeholder="Last Name"
                class="w-full border-round border-1 border-gray-300 overflow-hidden px-3"
                formControlName="user_last_name"
                style="height: 50px"
              />
            </div>
            <input
              type="text"
              placeholder="Email Address"
              class="w-full border-round border-1 border-gray-300 overflow-hidden px-3"
              formControlName="user_email"
              (input)="clearErrorMessage()"
              style="height: 50px"
            />

            <p-iconField iconPosition="right">
              <a
                class="pointer"
                *ngIf="!showPass"
                (click)="showPass = !showPass"
                ><p-inputIcon styleClass="pi pi-eye px-3"
              /></a>
              <a
                class="pointer"
                *ngIf="showPass"
                (click)="showPass = !showPass"
              >
                <p-inputIcon styleClass="pi pi-eye-slash px-3" />
              </a>
              <input
                type="{{ !showPass ? 'password' : 'text' }}"
                placeholder="Password"
                class="w-full border-round border-1 border-gray-300 overflow-hidden px-3"
                formControlName="user_password"
                style="height: 50px"
              />
            </p-iconField>

            <input
              type="text"
              placeholder="Phone Number"
              class="w-full border-round border-1 border-gray-300 overflow-hidden px-3"
              formControlName="user_phone"
              style="height: 50px"
            />

            <!-- <input
              type="text"
              placeholder="Company"
              class="w-full border-round border-1 border-gray-300 overflow-hidden px-3"
              formControlName="company_label"
              style="height: 50px"
            /> -->

            <div
              *ngIf="errorMessage"
              class="m-0 py-3 px-4 message bg-red-700 border-round text-0 text-lg flex gap-3 align-items-center"
            >
              <i
                class="pi pi-exclamation-triangle"
                style="font-size: 1.6rem; padding-bottom: 3px"
              ></i
              >{{ errorMessage }}
            </div>
            <p-button
              label="Create account"
              [rounded]="true"
              [style]="{ width: '100%', 'font-size': '15px' }"
              [disabled]="registerFormGroup.invalid"
              (click)="registerUser()"
              [loading]="isLoading"
              styleClass="border-round border-2 transition-colors hover:surface-900 hover:border-900 checkout-button"
            ></p-button>
            <p class="message">
              By creating an account, you agree to our Terms of Service and
              Privacy Policy, including your consent to us sending e-mails about
              promotions and discounts.
            </p>
            <p-divider [style]="{ 'font-size': '16px' }" align="center">
              Already have an account?
              <a
                (click)="callLogin()"
                style="
                  text-decoration: underline;
                  font-style: italic;
                  font-size: 16px;
                "
                class="pointer"
              >
                Sign In
              </a>
            </p-divider>
          </div>
        </div>
      </div>
    </form>
  </p-dialog>
</div>

<div class="custom-dialog">
  <p-dialog
    [draggable]="false"
    [modal]="true"
    [(visible)]="isLogout"
    class="progress-dialog"
    [closable]="false"
    [closeOnEscape]="false"
  >
    <div
      class="py-3 px-4 flex gap-4 text-xl align-items-center justify-content-center"
    >
      <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
      <div>Logging out....</div>
    </div>
  </p-dialog>

  <p-dialog
    [draggable]="false"
    [modal]="true"
    [(visible)]="isWelcome"
    styleClass="dialog-responsive pb-6 mx-3 m-md-0 custom-dialog"
    [closable]="true"
    [closeOnEscape]="true"
  >
    <div class="d-flex flex-column flex-md-row">
      <div class="col-12 col-md-12">
        <div class="flex justify-content-end pr-3 pt-3">
          <p-button
            styleClass="border-circle w-2rem h-2rem bg-gray-700 border-gray-700"
            icon="pi pi-times"
            (onClick)="isWelcome = 0"
          />
        </div>
        <div class="flex flex-column w-full px-3 px-md-5 pb-6 gap-4">
          <h1 class="text-900 text-center">
            Welcome {{ registerFormGroup.value.user_first_name }}
            {{ registerFormGroup.value.user_last_name }}
          </h1>
          <img
            src="https://worktraq-asset.s3.ca-central-1.amazonaws.com/upload/products/5284a47b222aad54140004ef-1738816818857--1738816818857.jpg"
          />
          <h4>Your email has not been verified</h4>
          <h4>
            Please wait until administrator active your email to continue.
          </h4>
          <h4>Thank you and have a nice day</h4>

          <p-button
            label="Close"
            [rounded]="true"
            [style]="{ width: '100%', 'font-size': '15px' }"
            (click)="isWelcome = 0"
            styleClass="border-round border-2 transition-colors hover:surface-900 hover:border-900 checkout-button"
          ></p-button>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
<p-toast />

<div>
  <!-- Scroll To Top Button -->
  <button
    pButton
    class="scroll-top-btn"
    icon="pi pi-arrow-up"
    (click)="scrollToTop()"
    *ngIf="showScrollButton"
  ></button>
</div>
